<ng-container *ngFor="let test of tests">
  <app-test-info [test]="test"></app-test-info>
</ng-container>
